import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pen",
  "use": "icon-pen-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-pen\"><defs><clipPath id=\"icon-pen_a\"><rect width=\"16\" height=\"16\" rx=\"0\" /></clipPath></defs><g clip-path=\"url(#icon-pen_a)\"><path d=\"M9.085 2.914l4.001 4-8.687 8.687-3.567.394a.75.75 0 0 1-.828-.828l.397-3.57 8.684-8.683zm6.475-.596L13.682.44a1.5 1.5 0 0 0-2.122 0L9.793 2.207l4 4L15.56 4.44a1.5 1.5 0 0 0 0-2.122z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol